
import { getProductById } from '@/lib/supabase/products';
import { Product } from '@/lib/supabase/products';
import { DEFAULT_BENEFITS, DEFAULT_FAQS } from '../product-save/defaults';
import { toast as toastFunction } from "@/hooks/use-toast";
import { ProductFormState } from '../types';

export async function fetchProductData(
  productId: string,
  toast: typeof toastFunction,
  onBack: () => void
): Promise<ProductFormState | null> {
  try {
    const productData = await getProductById(productId);
    if (!productData) {
      toast({
        title: 'Error',
        description: 'Product not found',
        variant: 'destructive',
      });
      onBack();
      return null;
    }

    console.log("Product data retrieved:", productData);
    console.log("Product shop_id:", productData.shop_id);
    console.log("Product form_id:", productData.form_id);
    console.log("Product organization_id:", productData.organization_id);
    
    // Prepare benefits with visibility property
    const processedBenefits = productData.benefits?.map(benefit => ({
      ...benefit,
      visible: benefit.visible !== false
    })) || [];
    
    // If no benefits are defined, use default benefits
    const benefits = processedBenefits.length > 0 ? processedBenefits : DEFAULT_BENEFITS;
    
    // Prepare FAQs with visibility property
    const processedFaqs = productData.faqs?.map(faq => ({
      ...faq,
      visible: faq.visible !== false
    })) || [];
    
    // If no FAQs are defined, use default FAQs
    const faqs = processedFaqs.length > 0 ? processedFaqs : DEFAULT_FAQS;
    
    return {
      product: productData,
      showSummary: !!productData.overview,
      name: productData.name || '',
      overview: productData.overview || '',
      description: productData.description || '',
      price: productData.price?.toString() || '',
      discountPrice: productData.discount_price?.toString() || '',
      sku: productData.sku || '',
      quantity: productData.stock_quantity || 0,
      initialQuantity: productData.stock_quantity || 0,
      lowStockThreshold: productData.low_stock_threshold || 5,
      isOutOfStock: (productData.stock_quantity || 0) <= 0,
      isStockManaged: productData.is_stock_managed || false,
      mediaUrls: productData.media_urls || [],
      category: productData.category || '',
      benefits: benefits,
      faqs: faqs,
      weight: productData.weight?.toString() || '',
      dimensions: productData.dimensions || { length: 0, width: 0, height: 0 },
      tags: productData.tags || [],
      isVisible: productData.is_visible !== false,
      status: productData.status || 'active',
      currency: productData.currency || 'DZD',
      shopId: productData.shop_id || '',
      formId: productData.form_id || null,
      organizationId: productData.organization_id || null
    };
  } catch (error) {
    console.error('Error fetching product:', error);
    toast({
      title: 'Error',
      description: 'Unable to retrieve product details',
      variant: 'destructive',
    });
    onBack();
    return null;
  }
}
